export default "__VITE_ASSET__D3aL_rof__"